export default {
  common_or: 'eller',
  common_placeholder_optional: 'Valgfritt',
  common_button_next: 'Neste',
  common_button_cancel: 'Avbryt',
  common_button_skip: 'Hopp over',
  common_button_ok: 'OK',
  common_button_back: 'Tilbake',
  common_button_yes: 'Ja',
  common_button_no: 'Nei',
  common_button_reset: 'Reset',
  common_error_title: 'Feil',
  common_error_message_webServiceWrongConnection: 'Det oppsto en feil under dataoverføringen. Prøv på nytt',
  common_error_message_noInternetConnection: 'Internettilkoblingen er borte. Prøv på nytt.',
  common_error_message_cameraNotAllowed: 'Tilgang til kamera må tillates for å kunne bruke denne funksjonen.',
  common_error_message_invalidCredentials: 'Oops! Brukernavn og/eller passord er feil. Prøv på nytt',
  common_error_message_unauthorizedAccess: 'Uautorisert tilgang',
  common_error_message_missingField: 'Obligatorisk felt',
  common_error_message_incorrectEmail: 'Skriv inn en korrekt e-postadresse',
  common_error_message_invalidMobile: 'Please enter a valid mobile phone number',
  common_error_message_ForbiddenException: 'Utilstrekkelige rettigheter',
  common_deactivated_title: 'Kiosk deactivated on this device',
  common_deactivated_message:
    'This kiosk has been activated on another device and is thus no longer active on this one. Please log in again. Thank you!',
  common_expired_title: 'Account expired',
  common_expired_message:
    'Either your trial has expired or the credit card we have on file stopped working. Please upgrade in order to re-activate the account. Contact sales@proxyclick.com if you have any questions. Thank you!',
  common_tooltip_gotIt_button: 'Forstått',
  common_tooltip_disable_button: 'Deaktiver alle tips',
  common_onboarding_message1: 'Proxyclick helps you singleTenantWelcome your visitors exactly the way you want to.',
  common_onboarding_message2:
    'Brand your check-in process and your badges, and ask your visitors only the questions that apply to them.',
  common_onboarding_message3: 'Hosts get notified when their guests arrive and can reply instantly.',
  common_onboarding_message4:
    'Protect your facilities and ensure compliance through emergency lists, watch lists, NDAs, privacy rules ...',
  common_onboarding_message5:
    'Proxyclick does the hard work so you can singleTenantWelcome your visitors with a smile.',
  common_onboarding_login_button: 'Log in',
  common_timeout_title: 'Tilbake til startskjermen',
  common_timeout_content: 'Trykk for å avbryte',
  common_enterEmail_title: 'Din e-post',
  common_enterEmail_email: 'Skriv inn e-posten du benytter på jobb',
  common_signup_title: 'Velkommen til Proxyclick',
  common_signup_name: 'Navn',
  common_signup_name_placeholder: 'Fornavn Etternavn',
  common_signup_company: 'Firma',
  common_signup_email: 'E-post',
  common_signup_password: 'Passord',
  common_signup_tryFree_button: 'Send',
  common_signup_error_name: 'Skriv inn for- og etternavn',
  common_signup_loading_title: 'Oppretter kontoen din …',
  common_signup_loading_message1:
    'Du kan tilpasse kiosken ved å koble til web-appen til Proxyclick. Vi har nettopp sent deg en e-post med alle detaljer.',
  common_signup_loading_message2: 'Fra nettsiden kan du sette opp skriveren til å skrive ut skilt ved innsjekking.',
  common_signup_loading_message3: 'Du kan også aktivere varselutsending til verten ved innsjekking.',
  common_signup_loading_message4: 'Tilpass kiosken din med dine enge farger og velkomstbilde.',
  common_setup_login_title: 'Logg inn med Proxyclick-kontoen din',
  common_setup_login_email: 'E-post',
  common_setup_login_password: 'Passord',
  common_setup_login_forgotPassword_button: 'Glemt passordet?',
  common_setup_login_activationCode_button: 'Activate with unique code?',
  common_setup_activationCode_title: 'Activate kiosk with unique code',
  common_setup_activationCode_code: 'Enter your activation code',
  common_setup_activationCode_code_placeholder: 'Eg. YSSFG-CVWVR-JFRWX-HSNMK',
  common_setup_activationCode_activate_button: 'Activate',
  common_setup_activationCode_footer: 'Activation code is handy for SSO admins or for local guards. Learn More.',
  common_setup_activationCode_error_invalidCode: 'Invalid activation code',
  common_setup_location_title: 'Velg nettsted',
  common_setup_location_footer: 'Koble til web-appen til Proxyclick for å opprette et nytt nettsted',
  common_setup_location_kiosks: 'kiosker',
  common_setup_location_kiosk: 'kiosk',
  common_setup_device_title: 'Velg din kiosk',
  common_setup_device_multiTenants: 'Flere selskaper',
  common_setup_device_footer: 'Koble til web-appen til Proxyclick for å opprette en ny kiosk',
  common_setup_device_locked_title: 'Kiosk allerede i bruk',
  common_setup_device_locked_content:
    'Denne kiosken er allerede i bruk på en annen iPad. Å sette den opp på iPaden du holder vil deaktivere den andre. Er du sikker du ønsker å sette opp kiosken på denne iPaden?',
  common_setup_device_locked_continue_button: 'Sett opp denne kiosken',
  common_setup_ready_title: 'Hei {0}',
  common_setup_ready_header: 'Er du klar til å sette opp denne iPaden som din {0} kiosk?',
  common_setup_ready_message: 'Det tar bare et minutt å konfigurere, og kiosken vil være opp og går',
  common_setup_ready_setup_button: 'Oppsett',
  common_setup_loading_title: 'Kiosken din settes opp...',
  common_setup_loading_message: 'Konfigurerer...',
  common_setup_loading_footer: 'Koble til web-appen til Proxyclick for å tilpasse kiosken din',
  vm_identification_qrCode_button: 'Skann invitasjonen/passet ditt',
  vm_identification_id_button: 'Skann ID-en din',
  vm_qrCode_help: 'Hold koden opp 10-15 cm fra kameraet',
  vm_qrCode_not_recognized: 'Koden ikke gjenkjent',
  vm_multiTenant_title: 'Velkommen, hvilket firma skal du besøke?',
  vm_welcome_qrCode_scan: 'Pre-registered Visitors: hold your QR code up to the camera for check-in or out',
  vm_welcome_qrCode_checkedIn: "Welcome {0}, don't forget to check out before leaving",
  vm_welcome_qrCode_checkedOut: 'Thank you for visiting, {0}!',
  vm_welcome_qrCode_notRecognized: 'This QR code is not recognized. Please try again.',
  vm_welcome_qrCode_wrongCompany: 'Your QR code is invalid for this location.',
  vm_welcome_changeLanguage_button: 'Change Language',
  vm_welcome_checkin_button: 'Sjekk inn',
  vm_welcome_checkout_button: 'Sjekk ut',
  vm_welcome_delivery_button: 'Levering',
  vm_welcome_returning_button: 'Been here before?',
  vm_welcome_tooltip_title: 'Gjør den til din egen',
  vm_welcome_tooltip_content:
    'Logg inn på web-appen til Proxyclick for å gi kiosken et personlig særpreg. Vi har nettopp sendt deg en e-post med instrukser. I web-appen kan du laste opp logoen din, bakgrunnsbilde og velge farge for å la kiosken gjenspeile identiteten til merket ditt.',
  vm_checkin_returning_email: "Hello, what's your email address?",
  vm_checkin_returning_email_notRegistered:
    'We could not find a scheduled visit linked to your email address. Please check with reception or try again with a different email address.',
  vm_checkin_method_name_enterFullName: 'Skriv inn ditt fulle navn',
  vm_checkin_method_name_invitationQuestion: 'Did you receive an invitation with a QR-code?',
  vm_checkin_method_tooltip_title: 'Gjenkjennelse av besøkende',
  vm_checkin_method_tooltip_content:
    'Sjekk inn som "Justin Diaz" for å se hvordan gjester som er førregistrerte eller som kommer tilbake, blir gjenkjent. \n\nEller du kan skrive inn et tilfeldig navn for å se hvordan uventede gjester blir adressert.',
  vm_checkin_idScan_disclaimer_text:
    'As part of our security policy, we need to verify your identity using your ID. \n\nWe value your privacy, so we will not store the picture of your ID. Reception officers are available to help if you have any questions.',
  vm_checkin_idScan_disclaimer_start_button: "Let's get started",
  vm_checkin_idScan_region_header: 'What region does your ID come from?',
  vm_checkin_idScan_region_0: ' United States',
  vm_checkin_idScan_region_1: ' Canada',
  vm_checkin_idScan_region_2: 'South America',
  vm_checkin_idScan_region_3: ' Europe',
  vm_checkin_idScan_region_4: ' Australia',
  vm_checkin_idScan_region_5: ' Asia',
  vm_checkin_idScan_region_6: ' General Documents',
  vm_checkin_idScan_region_7: ' Africa',
  vm_checkin_idScan_aila_header: 'Please scan your ID',
  vm_checkin_idScan_aila_scan_button: 'Scan ID',
  vm_checkin_idScan_aila_footer: 'This screen is skipped when you use the recommended hardware ({0})',
  vm_checkin_idScan_aila_learnMore: 'Learn more',
  vm_checkin_idScan_front_picture_header_aila: 'Place your ID in the holder so the front faces the camera.',
  vm_checkin_idScan_front_picture_header_noAila: 'Position your ID entirely inside the frame.',
  vm_checkin_idScan_front_picture_take_button: 'Scan front',
  vm_checkin_idScan_back_picture_header_aila: 'Place your ID in the holder so the back faces the camera.',
  vm_checkin_idScan_back_picture_header_noAila: 'Position the back of your ID entirely inside the frame.',
  vm_checkin_idScan_back_picture_take_button: 'Scan back',
  vm_checkin_idScan_match_check: 'Comparing the two pictures',
  vm_checkin_idScan_match_confirm_button: 'Confirm',
  vm_checkin_idScan_match_error_idExpired_header: 'Sorry, your ID seems to have expired.',
  vm_checkin_idScan_match_error_idExpired_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_idNoFace_header: 'Sorry, we could not identify a face on your ID.',
  vm_checkin_idScan_match_error_idNoFace_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_pictureNoFace_header: 'Sorry, we could not identify a face on the picture you took.',
  vm_checkin_idScan_match_error_pictureNoFace_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_default_header: 'Sorry, something went wrong.',
  vm_checkin_idScan_match_error_default_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_editName_title: 'Please fill in your first and last name',
  vm_checkin_idScan_cancel_title: 'Warning',
  vm_checkin_idScan_cancel_message: 'Check-in will be cancelled and you will return to home screen',
  vm_checkin_details_title: 'Please enter your details',
  vm_checkin_details_firstname: 'Fornavn',
  vm_checkin_details_lastname: 'Etternavn',
  vm_checkin_details_companyName: 'Firma',
  vm_checkin_details_email: 'E-post',
  vm_checkin_welcome_firstTime: 'Velkommen {{Visitor_FirstName}}!',

  vm_checkin_welcome_lastVisit_today: 'Your last visit was earlier today',
  vm_checkin_welcome_lastVisit_yesterday: 'Your last visit was yesterday',
  vm_checkin_welcome_lastVisit_date: 'Your last visit was on {0}',

  vm_checkin_host_enterFullName: 'Skriv inn vertens fulle navn',
  vm_checkin_host_unknown_button: 'Jeg vet ikke',
  vm_checkin_host_notListed_continue: 'Ikke på listen',

  vm_checkin_host_tooltip_title: 'Ankomstvarsel for besøkende',
  vm_checkin_host_tooltip_content:
    'Skriv inn navnet ditt her så sender vi e-postvarselet som dine ansatte vil få når deres besøkende ankommer.',

  vm_checkin_picture_take_button: 'Ta bilde',
  vm_checkin_picture_auto_lookCamera: 'Please look at the camera, we will take your visitor picture',
  vm_checkin_picture_auto_countDown: ' ',
  vm_checkin_picture_auto_stayStill: 'Remain still',
  vm_checkin_picture_auto_pictureTaken: 'Picture taken',
  vm_checkin_picture_tooltip_title: 'Valgfrie funksjoner',
  vm_checkin_picture_tooltip_content:
    'Du kan skreddersy kiosken behovene dine og enkelt legge til eller fjerne funksjoner, som for eksempel å ta bilde av de besøkende eller å skrive ut skilt.',
  vm_checkin_flow_tooltip_title: 'Smarte spørsmål',
  vm_checkin_flow_tooltip_content:
    'Spør gjesten din hva som helst for at du kan forbedre opplevelsen deres eller gjøre innsjekkingen sikrere. Du kan gjøre justeringer på spørsmålene avhengig av hva gjestene svarer. Svarene du ser er kun eksempler for demonstrasjonen.',
  vm_checkin_flow_error_message_imageNotAvailable:
    'Oops, bildet er ikke tilgjengelig akkurat nå (problem med nettilkoblingen)',
  vm_checkin_flow_email: 'E-post',
  vm_checkin_flow_licensePlate: 'Registreringsskilt',
  vm_checkin_flow_company: 'Firma',
  vm_checkin_flow_duration: 'Visit duration',
  vm_checkin_instructions_sign: 'Signer med fingeren her',
  vm_checkin_instructions_agreeTerms_button: 'Enig',
  vm_checkin_instructions_clearSignature_button: 'Tøm felt',
  vm_checkin_instructions_sendCopy_button: 'Send meg en kopi per e-post',
  vm_checkin_instructions_sendCopyTo_button: 'En kopi sendes til {0} (endre)',
  vm_checkin_instructions_tooltip_title: 'Klappet og klart',
  vm_checkin_instructions_tooltip_content:
    'La gjestene dine godta besøksreglene ved et tastetrykk eller singatur. Du kan tilpasse vilkårene avhengig av type innsjekking. Tilpass denne funksjonen og mange andre på instumentpanelet til Proxyclick.',
  vm_checkin_summary_visiting: 'Besøker {0}',
  vm_checkin_summary_meetingTime: 'Møte kl {0}',
  vm_checkin_summary_groupStats: '{0} av {1} er allerede kommet',
  vm_checkin_summary_agreementAlreadySigned: 'Agreement already signed',
  vm_checkin_summary_checkin_button: 'Sjekk inn',
  vm_checkin_summary_editDetails_button: 'Rediger detaljer',
  vm_checkin_summary_reviewDetails_button: 'Se over besøksdetaljene',
  vm_checkin_summary_takeNewPicture_button: 'Ta nytt bilde',
  vm_checkin_summary_sendPass_button: 'Send meg et pass til smarttelefonen min for fremtidige besøk',
  vm_checkin_summary_sendPassTo_button: 'Et permanent pass sendes til {0} (endre)',
  vm_checkin_summary_countDown: 'You will be checked in after',
  vm_checkin_saveInfo_title: 'Enter your email',
  vm_checkin_saveInfo_email: 'Save my info to speed up my next check-in',
  vm_checkin_saveInfo_email_placeholder: 'Enter your email address',
  vm_checkin_confirmation_takeBackID: "Please don't forget your ID",
  vm_checkin_error_message_unableToCheckIn: 'En feil oppsto under innsjekkingen, vennligst henvend deg i resepsjonen',
  vm_checkout_method_name_notFound: 'Ikke funnet',
  vm_infopack_likeCheckIn: 'Liked this check-in? Tap here to learn more',
  vm_infopack_likeProcess: 'Liked this process? Tap here to learn more',
  vm_infopack_email: 'Skriv inn e-posten din slik at vi kan sende deg mer informasjon om Proxyclick',
  vm_infopack_send_button: 'Send meg informasjon',
  vm_infopack_confirmation: 'Tusen takk! \nVi har sendt informasjonen til {0}.',
  vm_product_footer_partner: "You're using Proxyclick Welcome, brought to you by {0}",
  vm_product_footer_noPartner: "You're using Proxyclick Welcome",
  vm_product_footer_learnMore: 'Learn more',
  dm_delivery_recipient_unknown_button: 'Jeg vet ikke',
  dm_delivery_confirmation_title: 'Tusen takk!',
  em_multiTenant_notRegistered_button: 'Tap here to check in manually',
  em_multiTenant_alreadyRegistered_button: 'Tap here if you are an employee or have received a QR code to check in',
  vm_welcome_qrCode_show: 'Employees: scan this QR code with Proovr to check in or check out',
  vm_welcome_touchless_qrCode_show: 'Unregistered Visitors: Scan this QR code for touchless check-in',
  vm_welcome_touchless_unexpected_qrCode_show: 'Scan this QR code with your phone to check in as a visitor',
  vm_welcome_touchless_employee_qrCode_show: 'Scan this QR code with Proovr to check in as an employee',
  vm_welcome_touchless_unexpected_and_employee_qrCode_show:
    'Scan this QR code with Proovr (employees) or your phone (visitors) to check in',
  vm_checkin_video_subtitle: 'Watch the full video to continue your check-in.',
  vm_checkin_video_duration: 'Duration',
  vm_checkin_approval_notapproved_title: 'Dear {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_approval_notapproved_message:
    'We are unable to finalize your check-in at this time. Please contact your host or reach out to reception for assistance.',
  vm_checkin_approval_confirmation_unregistered_title: 'Welcome {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_approval_confirmation_unregistered_message:
    'We are unable to check you in at this time. Please contact your host or reach out the reception for assistance.',
  vm_checkin_qrcode_no_checkin_allowed: 'Checkin not allowed. Please contact the reception for assistance.',
  vm_signup_defaultInstruction_name: 'Alle besøkende skal skrive under på instruksjonene',
  vm_signup_defaultInstruction_title: 'Les og signer under',
  vm_signup_defaultInstruction_content:
    '<p style="text-align: center;"><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-wearbadge.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-assemblypoint.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nopic.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nosmoke.png" width="50"/><br/></p><h1>INSTRUKSER OG AVTALE OM TAUSHETSPLIKT FOR BESØKENDE</h1><p>Velkommen! Vi er glade for å ha deg fra {{Company_Name}} som gjest her hos oss.</p><h2>Instrukser angående helse og sikkerhet</h2><p>Under hele ditt besøk er din personlige sikkerhet vårt ansvar. Vi ber deg derfor følge disse instruksene:</p><ul><li><b>Tilgang til området</b> er kun tillatt i ledsagelse med en ansatt her ved {{Company_Name}}</li><li>Du må ha på deg <b>besøksskiltet</b> tilø enhver tid og levere det i resepsjonen ved avreise</li><li>I tilfelle en <b>nødsituasjon</b> må alle besøkende umiddelbart forlate området via nærmeste nødutgang og rapportere ved nærmeste samlingspunkt</li><li>Beøkende har <b>ikke lov til å ta bilder</b> (foto og video) av noe på innsiden av bygningene eller av områdene rundt fasilitetene</li><li><b>Røyking er ikke tillatt</b> i bygningene</li></ul><h2>Avtale om hemmeligholdelse</h2><p>Under ditt besøk av fasilitetene til {{Company_Name}} kan du få kunnskap om eller kjennskap til privat eller konfidensiell informasjon (inkludert, uten begrensning, informasjon relatert til teknologi, prosesser, utstyr, tegninger og spesifikasjoner) som ikke er allmennehten kjent (i det følgende samlet kalt &#34;Konfidensiell informasjon&#34;).</p><p>I forbindelse med tillatelse gitt deg til å besøke fasilitetene til {{Company_Name}} og den imøtekommenheten som du blir vist under besøket, går du med på å ikke;</p><p>(a) offentligjøre eller på annen måte tilgjengeliggjøre noen som helst konfidensiell informasjon til andre som du har fått kunnskap om og kjennskap til under dette og etterfølgende besøk; eller</p><p>(b) bruke eller hjelpe andre på noen som helst måte i å bruke eller videreutvikle noe som helst konfidensiell informasjon.</p><p>(c) Du går også med på ikke å bruke kameraer eller videoteknologi for å offentliggjøre eller tilgjengeliggjøre konfidensiell informasjon.</p><p>Ved å sjekke inn på fasilitetene har du anerkjent og forstått instruksene angående helse og sikkerhet og avtalen om hemmeligholdelse.</p>',
  vm_welcome_title: 'Velkommen til {{Company_Name}}',
  vm_welcome_hello_line1: 'Velkommen',
  vm_welcome_hello_line2: 'til {{Company_Name}}',
  vm_qrCode_title: 'Skann skiltet eller Passbook-koden din',
  vm_checkin_method_name: 'Hei, hva heter du?',
  vm_checkin_method_name_notRegistered_continue: 'Ikke på listen?',
  vm_checkin_method_name_notRegistered_block: 'Ikke på listen? Henvend deg i resepsjonen',
  vm_checkin_welcome_returning: 'Velkommen tilbake {{Visitor_FirstName}}!',
  vm_checkin_host_name: 'Hvem skal du besøke?',
  vm_checkin_host_notListed_block:
    'Hvis du ikke kjenner verten din eller ikke finner ham / henne på listen, vennligst drøft det med resepsjonisten',
  vm_checkin_picture_title: 'La oss ta et bilde av deg!',
  vm_checkin_flow_mobile: 'Skriv inn mobilnummeret ditt',
  vm_checkin_flow_mobile_info:
    'Dette vil bli brukt til å komme i kontakt med deg i tilfelle en nødsituasjon mens du er på anlegget',
  vm_checkin_summary_title: 'Ditt besøk fra {{Company_Name}}',
  vm_checkin_confirmation_title: 'Tusen takk!',
  vm_checkin_confirmation_header_withPrint: 'Skiltet ditt skrives ut',
  vm_checkin_confirmation_header_withoutPrint: 'Du er blitt registrert!',
  vm_checkin_confirmation_message: 'Sett deg gjerne ned, {{Host_FirstName}} vil være her om et øyeblikk',
  vm_checkout_method_title: 'Sjekke ut',
  vm_checkout_method_name: 'Please enter your name to check out',
  vm_checkout_confirmation_title: 'Takk for besøket!',
  vm_checkout_confirmation_header: 'På gjensyn, {{Visitor_FirstName}}!',
  vm_checkout_confirmation_message: 'Du er sjekket ut. Vi håper det har vært et hyggelig besøk.',
  dm_delivery_recipient_name: 'Who is this package for?',
  dm_delivery_confirmation_knownRecipient: '{{Host_Name}} har blitt informert om at du leverte en pakke',
  dm_delivery_confirmation_unknownRecipient:
    'Det er sendt en melding for å informere {{Company_Name}} om at du leverte en pakke for dem',
  vm_vaccine_certification_intro_question_title: 'Dear visitor, do you have an EU COVID Vaccine Certificate?',
  vm_vaccine_certification_declare_question_title:
    'Dear visitor, please declare whether you have a valid COVID vaccine certificate or a COVID test with a negative result',
  vm_vaccine_certification_scanner_title: 'Please present the QR code of your EU COVID certificate to the camera',
  vm_vaccine_certification_scanner_subtitle:
    'Make sure that your QR code is enlarged and the brightness of your mobile phone is on maximum.',
  vm_vaccine_certification_scanner_donthaveaqrcode: "I don't have a QR code",
  vm_vaccine_certification_accessDenied_title: 'Access has been denied',
  vm_vaccine_certification_accessDenied_message:
    "Sorry you don't meet the vaccination requirements to enter the premisses",
  vm_vaccine_certification_accessDenied_button: 'Okay',
};
